<section class="hd-conditioning-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-conditioning-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-conditioning-cheat-sheet-page__controls" aria-label="Niet-Zelf conditionering cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-conditioning-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-conditioning-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (title()) {
    <h2 class="hd-conditioning-cheat-sheet-page__title">{{ title() }}</h2>
  }
  @if (subtitle()) {
    <p class="hd-conditioning-cheat-sheet-page__subtitle">{{ subtitle() }}</p>
  }

  <div class="hd-conditioning-cheat-sheet-page__deck">
    <!-- Poster (Figma 1:1): grote centrale bodygraph met de blokken er absoluut omheen -->
    <div class="hd-conditioning-cheat-sheet-page__poster">
      <div class="hd-conditioning-cheat-sheet-page__stage">
        <hd-bodygraph-chart
          class="hd-conditioning-cheat-sheet-page__bodygraph"
          [configuration]="referenceConfig"
          [primaryGateAction]="'show-info'" />
      </div>

      @for (center of posterCenters; track center) {
        <hd-conditioning-card
          class="hd-conditioning-cheat-sheet-page__card hd-conditioning-cheat-sheet-page__card--{{ center }}"
          [center]="center" />
      }
    </div>

    <!-- Tekstblokken: conditioneringsimpact & poort-terminologie -->
    <div class="hd-conditioning-cheat-sheet-page__texts">
      <aside class="hd-conditioning-cheat-sheet-page__text-block">
        <markdown class="hd-conditioning-md" [src]="impactMarkdownUrl()"></markdown>
      </aside>
      <aside class="hd-conditioning-cheat-sheet-page__text-block">
        <markdown class="hd-conditioning-md" [src]="terminologyMarkdownUrl()"></markdown>
      </aside>
    </div>
  </div>
</section>
